<template>
  <el-dialog :visible.sync="dialogVisible" title="完成总结" width="800px">
    <!--   总结报告   -->
    <el-form>
      <summaryTaskTextbox
        ref="summaryTextbox"
        @getValue="summaryTaskTextbox"
        @SAVEKMS="saveKms"
        @upFile="upFile"
      ></summaryTaskTextbox>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveCompleteInfo">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveRecordCompleteInfo } from "@/api/modules/basicData/task.js";
import summaryTaskTextbox from "../components/summaryTaskTextbox";
import { getToken } from "../../../util/auth";
const cookieUser = getToken();
export default {
  components: {
    summaryTaskTextbox: () => import("../components/summaryTaskTextbox")
  },
  props: {
    recordId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dialogVisible: false,
      isSaveKnowledge: false,
      completeMemo: "",
      filePathList: []
    };
  },
  watch: {
    dialogVisible(newValue) {
      this.dialogVisible = newValue;
      if (newValue) {
        this.$nextTick(() => {
          this.$refs.summaryTextbox.onClear = 1;
        });

        this.isSaveKnowledge = false;
        this.completeMemo = "";
        this.filePathList = [];
      }
    }
  },
  methods: {
    saveCompleteInfo() {
      //保存
      saveRecordCompleteInfo(
        {
          RECORDID: this.recordId,
          CREATEUSERID: cookieUser.userId,
          CREATEUSERNAME: cookieUser.realName,
          CREATEDEPTID: cookieUser.departmentId,
          CREATEDEPTNAME: cookieUser.departmentName,
          CREATECOMPANYID: cookieUser.organizationId,
          CREATECOMPANYNAME: cookieUser.organizationName,
          SAVEKMS: this.isSaveKnowledge,
          MEMO: this.completeMemo
        },
        this.filePathList
      )
        .then(result => {
          if (result.ResultCode > 0) {
            this.$emit("successed");
            this.$message.success("保存成功");
          } else {
            this.$message.error(result.MsgInfo);
          }
        })
        .finally(() => {
          this.dialogVisible = false;
        });
    },
    // 总结报告
    summaryTaskTextbox(val) {
      console.log("总结报告", val);
      this.completeMemo = val;
    },
    saveKms(val) {
      //知识库
      console.log("知识库", val);
      this.isSaveKnowledge = val;
    },
    upFile(val) {
      this.filePathList = val;
    }
  }
};
</script>

<style lang="scss" scoped></style>
